import { EventStatus } from "@nxplatform/platform-entities/sport/common-sport.entities";
const liveStatuses = [EventStatus.online, EventStatus.stopped];
const lineStatuses = [EventStatus.line];
const isEventLive = (event) => !!event && liveStatuses.includes(event.status);
const isEventLine = (event) => !!event && lineStatuses.includes(event.status);
export {
  isEventLine,
  isEventLive,
  lineStatuses,
  liveStatuses
};
